import { CallbackObject } from 'api/core/get-page-function';
import { GetReceptionVm } from './get-reception.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getReception = async (reception: string, callback: CallbackObject<GetReceptionVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/reception/receptions/${reception}`, config);
    callback.success(plainToClass(GetReceptionVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
